export enum MyReceiptsStepEnum {
    MyReceipts = 'My receipts',
    MyRecurringCardPayments = 'My Recurring Card Payments',
    MyDirectDebits = 'My Direct Debits'
}